import { useEffect } from 'react';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://delegate.petergits.com';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Jessica — Your Delegate',
    url: siteUrl,
    description:
      'Jessica AI joins your meetings on your behalf, represents you in the room, summarises in real time, and brings you in only when you actually need to be there.',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Jessica AI Meeting Delegate',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    url: siteUrl,
    description:
      'An AI meeting delegate that attends meetings on your behalf, summarises in real time, monitors for your approval, and dials you in only when needed.',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
      description: 'Join the waitlist for early access.',
    },
    featureList: [
      'Joins meetings on your behalf',
      'Real-time meeting summaries',
      'Approval monitoring',
      'On-demand dial-in',
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Jessica — Your Delegate',
    url: siteUrl,
    description:
      'Building Jessica, the AI meeting delegate that represents you in the room so you don\'t have to be.',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/#webpage`,
    url: siteUrl,
    name: 'Jessica AI Meeting Delegate — Attend Meetings For You',
    description:
      'Jessica AI joins your meetings on your behalf, represents you in the room, summarises in real time, and brings you in only when you actually need to be there.',
    inLanguage: 'en',
    isPartOf: {
      '@type': 'WebSite',
      url: siteUrl,
    },
  },
];

export default function HomeSEO() {
  useEffect(() => {
    const existingScripts = document.querySelectorAll(
      'script[data-schema="home-jsonld"]'
    );
    existingScripts.forEach((s) => s.remove());

    jsonLd.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'home-jsonld');
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document
        .querySelectorAll('script[data-schema="home-jsonld"]')
        .forEach((s) => s.remove());
    };
  }, []);

  return null;
}
